import { render, staticRenderFns } from "./NoteEditor.vue?vue&type=template&id=70c5c53c"
import script from "./NoteEditor.vue?vue&type=script&lang=js"
export * from "./NoteEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports